import { useCustomRetryProposalPackageSendRecipientsMutation } from "generated/graphql";

export default function useRetryProposalPackageSendRecipients() {
  return useCustomRetryProposalPackageSendRecipientsMutation({
    refetchQueries: ["customGetProposalPackageSummary", "customGetProposals"],
  });
}
